// import { Request } from '@konv/http'
import { EnvironmentStorage } from '../shared/tools/EnvironmentStorage';
import { RequestClass } from "@konv/http";

const Request = new RequestClass("http://localhost:4200/addresses"); 

export class AddressesAPI {
	static async request({ endpoint = '/', method = 'GET', query }) {
		return await Request.request({
			endpoint: endpoint,
			method: method,
			service: 'addresses',
			ignoreVersion: true,
			params: query,
		});

	}

	static async searchAddresses(q, token) {
		const environmentId = EnvironmentStorage.getSelectedEnvironment();
		return await AddressesAPI.request({
			endpoint: `/search`,
			method: 'GET',
			query: { q, token, environmentId }
		})
	}

	static async getAddressById(id, token) {
		const environmentId = EnvironmentStorage.getSelectedEnvironment();
		return await AddressesAPI.request({
			endpoint: `/places/${id}`,
			method: 'GET',
			query: { token, environmentId }
		})
	}
}
